exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/node_modules/postcss-loader?{"ident":"postcss"}!/Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles